import { requester } from '../utils';

export const getCafeTablesByCafeId = cafeId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe/${cafeId}/tables`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.error('fetchCafeTableNumbers error', err);
        reject(err);
      });
  });
};
